// extracted by mini-css-extract-plugin
export var wrapper = "footer-module--wrapper--2gMYR";
export var column = "footer-module--column--2Zv_-";
export var logo = "footer-module--logo--3Xe1h";